<template lang="pug">
  .wrapper
    hero
    intro
    site-header
    main.sess
      #program.page-inner
        h2 プログラム
        .sess__list(v-for='session in sessions' :key='session.id' :id='session.id')
          template(v-if='session.break')
            p Break / Q&amp;A (5min)
          template(v-else='')
            h1.sess__title
              | {{ session.title[0] }} <br> {{ session.title[1] }}
          .sess__wrapper
            .sess__speaker
              speaker(:val='session.speakers' :prof='false' :sessId='session.id')
            button.btn(@click='openModal(session)' v-if='session.description[0]') セッション詳細
        modal(:post='postItem' v-show='showContent' @close='closeModal()')
    sponsor
    detail
    infectionControl
    site-footer
</template>


<script>
import Hero from "@/components/Hero.vue";
import Intro from "@/components/Intro.vue";
import siteHeader from "@/components/Header.vue";
import siteFooter from "@/components/Footer.vue";
import Speaker from "@/components/Speaker.vue";
import Modal from "@/components/Modal.vue";
import Sponsor from "@/components/Sponsor.vue";
import Detail from "@/components/Detail.vue";
import infectionControl from "@/components/Infectioncontrol.vue";
import Register from "@/components/Register.vue";

import sessions from "@/assets/sessions.json";
import items from "@/assets/speaker.json";

export default {
  name: 'top',
  components: {
    Hero,
    Intro,
    siteHeader,
    siteFooter,
    Modal,
    Speaker,
    Sponsor,
    Detail,
    infectionControl,
    Register
  },
  data() {
    return {
      showContent: false,
      postItem: "",
      sessions: sessions,
      items: items,
      isOpen: false
    };
  },
  methods: {
    openModal(item) {
      this.showContent = true;
      this.postItem = item;
      document.body.className = "modal-open";
    },
    closeModal() {
      this.showContent = false;
      document.body.className = "";
    },
    handleScroll() {
      document.querySelector(".header").classList.remove('-open');
    }
  },
  updated() {
    this.$el.querySelector(".overlay").scrollTop = 0;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

main.sess {
  background-color: #222;
  width: 100%;
  display: block;
}

.wrapper {
  margin-top: 72px;
}

.modal-open {
  overflow: hidden;
}

.page-inner {
  max-width: 800px;
  margin: 0 auto;
  background-color: transparent;

  & > h2 {
    text-align: center;
    color: #fff;
  }
}

.sess__wrapper {
  z-index: 10;
  position: relative;
  padding: 30px 40px;
  background-color: #fff;

  @media screen and (min-width: 767px) {
    padding-top: 0;
  }
}

.sess__list {
  position: relative;
  z-index: 1;
  margin-top: 60px;
}

.sess__list + .sess__list {
  margin-top: 80px;
}

.sess__time {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;

  span {
    font-size: 11px;
    padding-left: 5px;
  }
}

.sess__title {
  font-size: 20px;
  font-weight: 400;
  color: #fff;
  position: relative;
  padding-bottom: 10px;
  padding-top: 8px;
  margin-bottom: 0;
  margin-right: 1rem;

  span {
    font-size: 16px;
  }

  @media screen and (min-width: 769px) {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;

    border-top: 1px solid #fff;
    border-right: 1px solid #fff;

    span {
      display: block;
    }
  }
}

.sess__list > .sess__title {
  padding-left: .5rem;
  border-left: 1rem solid #efad1f;

  @media screen and (min-width: 769px) {
    &::after{
      position: absolute;
      content: '';
      width: 16px;
      height: 16px;
      background-image: url(/SAPCXDAY/img/circle.svg);
      background-repeat: no-repeat;
      right: -8px;
      top: -8px;
    }
  }
}

.sess__list:nth-of-type(2n) .sess__title {
  //border-left-color: #c0b12b;
}

.sess__list:nth-of-type(3n) .sess__title {
  //border-left-color: #93b438;
}

.sess__list:nth-of-type(4n) .sess__title {
  //border-left-color: #55b948;
}

.sess__speaker {
  margin: 0 -15px;
}

.sess__speaker h3 {
  margin: 40px 15px 0;
}

.sess__speaker + .btn {
  margin-top: 30px;
}

@media screen and (min-width: 769px) {

}

.sess__description {
  margin-top: 40px;
}

#sess01 .c-wrapper .speaker:first-of-type {
  flex-basis: 100%;
}
</style>